function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import { getToken, getUserInfo } from '@gaodun.com/rainbow';
import { getCookie, setCookie } from "../utils/cookie";
import { jsbridgeRun } from "../utils/jsbridge";
import { ACCESS_TOKEN, REFRESH_TOKEN, TOKEN_SOURCE, USER_INFO, VISITOR_TOKEN, WX_USER_DATA } from "../utils/keys";
import LStorage from "../utils/lStorage";
/**
 * 保存用户登录后的信息
 * @param data 登录返回信息
 */
export var setUserLoginInfo = function setUserLoginInfo(data) {
  var accessToken = data.accessToken,
    refreshToken = data.refreshToken,
    result = data.result;
  // 保存token及用户信息
  setCookie(ACCESS_TOKEN, accessToken);
  setCookie(REFRESH_TOKEN, refreshToken);
  LStorage.set(USER_INFO, result.UserData);

  // app 环境下使用gdclass的登录，标识token使用从cookie中获取
  jsbridgeRun({
    new: function _new() {
      var _sessionStorage;
      (_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.setItem(TOKEN_SOURCE, 'cookie');
    }
  });
};

/**
 * 检查微信授权
 * @param visitor 是否允许游客访问
 * @returns token
 */
export var getUserLoginInfo = function getUserLoginInfo() {
  return new Promise(function (resolve, reject) {
    var _sessionStorage2;
    var opts = {
      new: function _new() {
        var visitToken = getCookie(VISITOR_TOKEN);
        Promise.all([getToken(), getUserInfo()]).then(function (res) {
          var _res = _slicedToArray(res, 2),
            appToken = _res[0],
            appUserinfo = _res[1];
          var localToken = ((appToken === null || appToken === void 0 ? void 0 : appToken.accessToken) || '').replace('Basic ', '');
          // 重写app用户信息对应h5参数名
          var nickName = appUserinfo.nickName,
            sessionID = appUserinfo.sessionID,
            studentID = appUserinfo.studentID,
            uid = appUserinfo.uid,
            userImage = appUserinfo.userImage,
            userPhone = appUserinfo.userPhone;
          var userInfo = {
            Phone: userPhone,
            NickName: nickName,
            PictureUrl: userImage,
            SessionID: sessionID,
            StudentId: studentID,
            Uid: uid
          };
          var wxUserInfo = {};
          var needPhoneBind = !localToken || !userInfo || !userInfo.Phone;
          resolve({
            accessToken: localToken,
            visitToken: visitToken,
            userInfo: userInfo || {},
            wxUserInfo: wxUserInfo || {},
            needPhoneBind: needPhoneBind
          });
        }).catch(function (e) {
          resolve({
            accessToken: '',
            visitToken: visitToken,
            userInfo: {},
            wxUserInfo: {},
            needPhoneBind: true
          });
        });
      },
      web: function web() {
        var localToken = getCookie(ACCESS_TOKEN);
        var visitToken = getCookie(VISITOR_TOKEN);
        var userInfo = LStorage.get(USER_INFO);
        var wxUserInfo = getCookie(WX_USER_DATA);
        // 没有登录 || 没有用户信息 || 没有手机号
        var needPhoneBind = !localToken || !userInfo || !userInfo.Phone;
        resolve({
          accessToken: localToken,
          visitToken: visitToken,
          userInfo: userInfo || {},
          wxUserInfo: wxUserInfo || {},
          needPhoneBind: needPhoneBind
        });
      }
    };
    var source = (_sessionStorage2 = sessionStorage) === null || _sessionStorage2 === void 0 ? void 0 : _sessionStorage2.getItem(TOKEN_SOURCE);
    if (source === 'cookie') {
      opts.web();
    } else {
      jsbridgeRun(opts);
    }
  });
};